import React from "react";
import "./culture.css";
import CultureCard from "../../common/culture_card/CultureCard";
import data from "../../../configs/culture/culture.json";
import Carousel from "../../common/carousel/Carousel";
import InfoBox from "../../common/infobox/Infobox";

export default function Culture() {
  return (
    <div className="culture-sheet" id="Culture">
      <header className="culture-heading">Culture</header>
      <div className="culture-text">
        <p>
          Our values define who we are, what we want to achieve and most
          importantly how we’re going to do it. They create our collective path
          and guide our every step, every action. When in doubt, they’re the
          clarity we need and when we’re on our way to achieve big things,
          they’re the confirmation we want.
        </p>
      </div>
      <div className="row culture-cards">
        {data["culture-card"].map((culture) => {
          return (
            <div className="col-6 col-xl-3 col-md-4">
              <CultureCard
                cardCount={"01"}
                heading={culture.heading}
                imageURL={culture.imageLink.web}
                modalImage={culture.modalImage}
                description={culture.description}
                keyPoints={culture.keyPoints}
              />
            </div>
          );
        })}
      </div>
      <div className="culture-blog">Blogs & Documents</div>
      <div className="culture-blog-card">
        {window.innerWidth > 768 && (
          <Carousel
            width={1176}
            items={3}
            size={data.blogs.length}
            showDot={true}
            showArrow={true}
          >
            {data.blogs.map((blog) => {
              return (
                <InfoBox
                  title={blog.title}
                  description={blog.description}
                  image={blog.imageLink.web}
                  link={blog.navigationLinks[0]}
                  socialMedia={false}
                />
              );
            })}
          </Carousel>
        )}
        {window.innerWidth <= 768 && (
          <Carousel
            width={359}
            items={1}
            size={data.blogs.length}
            showDot={true}
            showArrow={true}
          >
            {data.blogs.map((blog) => {
              return (
                <InfoBox
                  title={blog.title}
                  description={blog.description}
                  image={blog.imageLink.web}
                  link={blog.navigationLinks[0]}
                  socialMedia={false}
                />
              );
            })}
          </Carousel>
        )}
      </div>
    </div>
  );
}
